import React, { useState, useContext } from 'react'
import { deleteCookie, parseJwt } from '../../../helper/genericFunction'
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import Icons from '../../../assets/icons';
import MergeAccountModal from './MergeAccountModal';
import ParentModal from '../../../genericComponents/ParentModal';
import FullPageLoader from '../../../loaders/FullPageLoader';
import { InitialAnnouncementModal } from '../../../initialPhaseOperations/InitialAnnouncementModal';
import { ReloadContext, UserDetailsContext } from '../../../App';
import { dispatchHandler } from '../../../helper/apiHelperFunctions';
import { useDispatch } from 'react-redux';

const HeaderStrip = (props) => {
    const dispatch = useDispatch();
    const { handleDocumentStatusChange } = useContext(ReloadContext);
    const {clearUserContext} = useContext(UserDetailsContext);
    const [selectedModal, setSelectedModal] = useState("");

    const tokenData = parseJwt(sessionStorage.getItem("token"));

    const getValue = () => {
        let loginStripMessage = tokenData?.loginStripMessage;
        let loggedMessageArray = loginStripMessage?.split(" ");
        let asIndex = loggedMessageArray?.indexOf("as");
        let fromIndex = loggedMessageArray?.indexOf("from");
        let firstName = loggedMessageArray?.slice(asIndex + 1, fromIndex).join(" ");
        let lastName = loggedMessageArray?.slice(fromIndex + 1).join(" ");
        return {
            firstName,
            lastName
        }
    }

    // Function : To handle the merging of the account
    const handleMergeAccount = () => {
        setSelectedModal("mergeAccountModal");
    }

    const getChildComponent = () => {
        switch (selectedModal) {
            case "mergeAccountModal": return MergeAccountModal
            case "fullPageLoader": return FullPageLoader;
        }
    }

    const logoutFunction = async () => {
        setSelectedModal("fullPageLoader")
        dispatchHandler(dispatch, "userSessionCreateRequest", { token: sessionStorage.getItem('token') || "", flowType: "LOGGEDOUT" });
        deleteCookie('jwt')
        sessionStorage.clear();
        clearUserContext?.();
        setTimeout(() => {
            setSelectedModal(false);
            handleDocumentStatusChange();
        }, 1000);
    }

    const getParentChildProps = () => {
        switch (selectedModal) {
            case "mergeAccountModal": {
                return {
                    closeModal: () => { setSelectedModal(false) },
                    animationType: "bottom",
                    // postitionProps: { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', position: "fixed", borderRadius: 4 },
                    parentModalOuterMostClassName: 'flex items-center justify-center',
			        postitionProps: { position: 'relative' },
                    dimensions: { width: "40vw", height: "80vh", maxHeight: '660px', maxWidth: '600px' },
                    submitModal: () => {
                        logoutFunction();
                    }
                }
            }
            case "fullPageLoader": {
                return {}
            }
        }
    }

    return (
        <React.Fragment>
            {tokenData?.["loginStripMessage"] ?
                <div className="show-logged-strip">
                    <p className='flex items-center gap-2'>
                        <div className="strip-info-icon">
                            <Icons.LoginStripIcon />
                        </div>
                        {/* {loginStripMessage} */}
                        <span>Currently you are logged in as</span>
                        <div className='px-2.5 h-[26px] flex items-center rounded-full border border-[#A9A8A8]'>{getValue()?.firstName}</div> from
                        <div className='px-2.5 h-[26px] flex items-center rounded-full border border-[#A9A8A8]'>{getValue()?.lastName}</div>
                    </p>
                </div> : null
            }
            {
                (tokenData?.uType === "VENDOR" && +tokenData?.isMergeEligible === 1) ? <div className="show-logged-strip">
                    <p className='flex items-center gap-2'>
                        <div className="strip-info-icon">
                            <Icons.LoginStripIcon />
                        </div>
                        <label className='!m-0'>One click away from account merge!</label>
                        Complete the merging process now to avail benefits of merging and access your account from one place.
                        {/* <span onClick={handleMergeAccount}>Know More</span> */}
                        <GenericCustomButton
                            type='underline2'
                            label={'Know More'}
                            onClick={handleMergeAccount}
                        />
                        <GenericCustomButton
                            type='primary'
                            size='small'
                            className='complete-merge-btn'
                            label="Complete Merge Process"
                            onClick={() => handleMergeAccount()}
                        />
                    </p>
                </div> : null
            }

            {/* componet for the announcemnts */}
            {/* to render the annoucement and the final subscription */}
            <InitialAnnouncementModal tokenData={tokenData} isMergeAccountStripVisible={tokenData?.uType === "VENDOR" && +tokenData?.isMergeEligible === 1} {...props}/>


            {selectedModal && <ParentModal
                childComponent={getChildComponent()}
                getParentChildProps={getParentChildProps()}
                closeModal={() => setSelectedModal(false)}
            />}
        </React.Fragment>
    )
}

export default HeaderStrip